import { useEffect } from 'react';
import { addClickTrackingOnLinks } from './utils';
export function useClickTracking(ref, onLinkClick) {
    useEffect(function () {
        var linksWithListener = [];
        if (ref.current) {
            linksWithListener = addClickTrackingOnLinks({
                domNode: ref.current,
                onLinkClick: onLinkClick,
            });
        }
        return function () {
            linksWithListener.forEach(function (linkWithListener) {
                linkWithListener.link.removeEventListener('click', linkWithListener.listener, true);
                linkWithListener.link.removeEventListener('auxclick', linkWithListener.listener, true);
            });
        };
    }, [ref.current]);
}
